export default __webpack_public_path__ + "static/media/img-trabajo-3.b9f66a25.jpg";